import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'SelectElement',
  props: ['dataObj'],
  components: {
    ElementComp: require('../../element.vue').default
  },
  data: function () {
    return {
      elementData: {
        elemenTypeDisabled: false,
        elementTypeId: -1,
        elementId: -1
      },
      tasks: [],
      message: ''
    };
  },
  computed: {
    elementId: function () {
      return this.elementData.elementId;
    }
  },
  watch: {
    elementId: function (value) {
      this.dataObj.appData.elementId = value;
    }
  },
  created() {
    this.$root.$on('om_select_element_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.elementData.elementId = this.dataObj.appData.elementId;
        this.elementData.elementTypeId = this.dataObj.appData.elementTypeId;
        this.$root.$emit('element_data_updated');
      });
    },
    getTasks() {
      axios
        .post('/EmployeeApplication/GetSelectionTaskItems', { Value: this.appData.appId })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.tasks = response.data.items;
            if (this.tasks.length == 1) this.appData.activityId = this.tasks[0].activityId;
          } else this.$alertMsg(response.data.data.text);
        })
        .catch((e) => {
          this.$router.push('/login');
        });
    }
  }
};
